<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <v-card class="pa-3">
          <v-card-title>
            <h4>{{$t($route.meta.breadcrumb[2].text)}}</h4>
          </v-card-title>
          <v-card-subtitle>
            <p>{{$t('unitTypes.formMessage')}}</p>
          </v-card-subtitle>
          <v-card-text>
            <div v-if="loading">
              <v-progress-linear
                indeterminate
                :active="loading"
                color="primary"
              ></v-progress-linear>
              <p class="text-center">{{$t('general.loading')}}</p>
            </div>
            <v-form
              v-if="!loading"
              lazy-validation
              ref="form"
              v-model="valid">
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    dense
                    :rules="rules.required"
                    v-model="unitType.name"
                  >
                    <template v-slot:label>
                      <span>{{$t('general.name')}}</span><span class="error--text">&nbsp;*</span>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12">
                  <v-btn
                    @click="save"
                    class="float-right"
                    color="primary">
                    {{$t('general.save')}}
                  </v-btn>
                   <v-btn
                    @click="redirect"
                    class="float-right mr-3"
                    outlined
                    color="primary">
                    {{$t('general.cancel')}}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      new: false,
      valid: true,
      loading: false,
      idEdit: null,
      unitType: {
        id: 0,
        name: ''
      }
    }
  },
  created () {
    if(this.$route.path === '/unit-types/add') {
      this.new = true
    } else {
      this.loading = true
      this.idEdit = this.$route.params.id
      this.$store.dispatch('unitTypes/getById', {
        event: {
          context: this,
          id: this.idEdit
        }
      })
    }
  },
  computed: {
    rules () {
      return this.$validationRules()
    }
  },
  methods: {
    save () {
      if (this.$refs.form.validate()) {
        if (this.new) {
          this.$store.dispatch('unitTypes/post', {
            event: {
              context: this,
              params: {
                name: this.unitType.name
              }
            }
          })
        } else {
          this.$store.dispatch('unitTypes/put', {
            event: {
              context: this,
              id: this.idEdit,
              params: {
                name: this.unitType.name
              }
            }
          })
        }
      }
    },
    redirect () {
      this.$router.push('/unit-types')
    }
  }
}
</script>